// extracted by mini-css-extract-plugin
export default {"root":"layout_root__OTPB6","content":"layout_content__-05v8"};